import React, { useState } from 'react';
import { TextField, TextInput, SimpleForm, RecordContextProvider, useRecordContext, useTranslate, useNotify, useRefresh, useGetIdentity } from 'react-admin';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import EditIcon from '@mui/icons-material/Edit';
import { useWatch, useFormContext } from 'react-hook-form';
import { grey } from '@mui/material/colors';
import moment from 'moment';

import MultilineTextField from '../common/fields/MultilineTextField';
import HumanDateField from '../common/fields/HumanDateField';


// import { addProjectComment, updateProjectComment } from '../../services/api';
let addProjectComment, updateProjectComment;

const ButtonForm = ({ commentId, setCommentId }) => {
	const record = useRecordContext();
	const { setValue } = useFormContext();
	const content = useWatch({ name: 'content' });
	const translate = useTranslate();
	const notify = useNotify();
	const refresh = useRefresh();

	const handleAddComment = async () => {
		const formData = new FormData();
		formData.append('content', content);
		const response = await addProjectComment(record.id, JSON.stringify({ content }));

		if (response.id) {
			setValue('content', '');
			notify(`Comment added`);
			refresh();
		} else {
			notify('Comment could not be added', 'warning');
		}
	};

	const handleUpdateComment = async () => {
		const formData = new FormData();
		formData.append('content', content);
		const response = await updateProjectComment(commentId, JSON.stringify({ content }));

		if (response.id) {
			setValue('content', '');
			notify(`Comment updated`);
			setCommentId(null);
			refresh();
		} else {
			notify('Comment could not be updated', 'warning');
		}
	};

	const handleCancel = () => {
		setCommentId(null);
	};

	return (
		<Box display="flex" gap={1}>
			<Button variant="contained" onClick={commentId ? handleUpdateComment : handleAddComment} sx={{ marginTop: 1 }}>{commentId ? translate('Update') : translate('Add')}</Button>
			{commentId && <Button variant="outlined" onClick={handleCancel} sx={{ marginTop: 1 }}>{translate('Cancel')}</Button>}
		</Box>
	);
};

const CommentForm = ({ commentId, setCommentId, ...props }) => {
	return (
		<SimpleForm toolbar={false} sx={{ padding: 0 }}>
			<TextInput source="content" label={commentId ? "" : "Comment"} fullWidth multiline rows="4" helperText={false} />
			<ButtonForm commentId={commentId} setCommentId={setCommentId} />
		</SimpleForm>
	);
};

const btnSx = {
	padding: '2px',
	minWidth: 'auto',
	color: grey[300],
	'&:hover': {
		color: grey[400]
	}
};

const ProjectComments = () => {
	const [editCommentId, setEditCommentId] = useState();
	const record = useRecordContext();
	const { data: account } = useGetIdentity();
	const translate = useTranslate();

	// TODO: remove fake data
	const comments = [
		{ id: 4, user_id: null, content: 'Status updated: maintenance', user: null, created_at: '2025-10-17 10:30', updated_at: '2025-10-17 10:30' },
		{ id: 3, user_id: 1, content: 'Test', user: { id: 1, fullname: 'Khalid Yagoubi' }, created_at: '2025-10-08 10:00', updated_at: '2025-10-08 10:00' },
		{ id: 2, user_id: 2, content: 'Lorem ipsum', user: { id: 2, fullname: 'Hélène Quoitot' }, created_at: '2025-10-07 10:30', updated_at: '2025-10-07 10:30' },
		{ id: 1, user_id: null, content: 'Status updated: active', user: null, created_at: '2025-10-07 09:30', updated_at: '2025-10-07 09:30' }
	];

	return (
		<Box>
			{comments?.map((comment, index) => (
				<RecordContextProvider value={comment} key={`${index}_${comment.id}`}>
					<Box display="flex" flexDirection="column" pb={3}>
						<Box display="flex" alignItems="center" gap={1} mb={1}>
							<Avatar sx={{ bgcolor: comment?.user?.color, fontSize: '14px' }}>{comment?.user?.trigram}</Avatar>
							<TextField source="user.fullname" sx={{ fontWeight: 'bold' }} record={comment} />
							<HumanDateField source="created_at" record={comment} sx={{ color: 'gray' }} />
							{(comment?.user_id === account?.id) && (
								<Button size="small" sx={btnSx} color="inherit" onClick={() => setEditCommentId(comment.id)}>
									<EditIcon fontSize="small" />
								</Button>
							)}
						</Box>
						{editCommentId === comment?.id ? (
							<CommentForm commentId={editCommentId} setCommentId={setEditCommentId} record={record} />
						) : (
							<>
								{/* <MultilineTextField source="content" record={comment} sx={{ marginBottom: 3 }} /> */}
								<MultilineTextField source="content" record={{...comment, content: translate(comment.content)}} sx={{ marginBottom: 3 }} />
								{!moment(comment.created_at).isSame(comment.updated_at, 'minute') && (
									<Typography sx={{ color: 'gray', fontSize: 12, mb: 1 }}>
										({translate('updated')} <HumanDateField source="updated_at" record={comment} sx={{ fontSize: 12 }} />)
									</Typography>
								)}
							</>
						)}

						{index < comments?.length - 1 && (
							<Divider />
						)}
					</Box>
				</RecordContextProvider>
			))}
			<CommentForm />
		</Box>
	);
};

export default ProjectComments;